/* eslint-disable  */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import { productActionCreators } from "../../services/Actions";
import { GetUserProfile } from "../../services/Actions/authActions";
import RenderHirePurchasePage from "../RenderHirePurchasePage";
import * as moment from "moment";
import Loader from "../../Components/Loader";
import { ToastContainer, toast } from "react-toastify";
import ReactPaginate from "react-paginate";
import { debounce } from "lodash";
import {
  FiSearch,
  FiMoreVertical,
  FiChevronRight,
  FiCalendar,
  FiBriefcase,
} from "react-icons/fi";

function ProcessedOrder() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { GetInitiatedOrders, ResetProductResponse } = bindActionCreators(
    productActionCreators,
    dispatch
  );

  const product = useSelector((state) => state.product);
  const { isLoading, orders, response, paginate } = product;
  const [limit, setLimit] = useState(15);
  const [pageCount, setPageCount] = useState(0);

  useEffect(() => {
    setPageCount(Number(paginate?.total) || 0);
  }, [paginate]);

  useEffect(() => {
    dispatch(GetUserProfile());
    GetInitiatedOrders(true, 1, limit, null);
  }, []);

  useEffect(() => {
    GetInitiatedOrders(true, 1, limit, null);
  }, [limit]);

  const handlePageClick = (event) => {
    GetInitiatedOrders(true, event.selected + 1, limit, null);
  };

  const onSearchTextChange = debounce((e) => {
    const val = e?.target?.value;
    GetInitiatedOrders(true, 1, limit, val ? `&search=${val}` : null);
  }, 800);

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      setTimeout(() => ResetProductResponse(), 1500);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => ResetProductResponse(), 1500);
    }
  }, [response?.state]);

  return (
    <div className="min-h-screen bg-gray-50/50">
      <RenderHirePurchasePage>
        {isLoading && <Loader />}

        {/* --- Header & Search Bar --- */}
        <div className="mb-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">
            Booked Orders
          </h2>

          <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex flex-col md:flex-row gap-4 items-center justify-between">
            <div className="relative w-full md:max-w-md">
              <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-gray-400">
                <FiSearch />
              </span>
              <input
                type="search"
                className="block w-full pl-10 pr-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all"
                placeholder="Search by staff ID or name..."
                onChange={onSearchTextChange}
              />
            </div>

            <div className="flex items-center gap-3">
              <label className="text-sm font-medium text-gray-500">Show:</label>
              <select
                className="bg-gray-50 border border-gray-200 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 outline-none"
                onChange={(e) => setLimit(e.target.value)}
                value={limit}
              >
                {[15, 25, 50, 100, 200].map((num) => (
                  <option key={num} value={num}>
                    {num} items
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* --- Table Container --- */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-100">
              <thead className="bg-gray-50/80">
                <tr>
                  <th className="px-6 py-4 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">
                    Customer
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">
                    Affordability
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">
                    Date Booked
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">
                    Facility
                  </th>
                  <th className="px-6 py-4 text-right"></th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-50">
                {orders?.length > 0 ? (
                  orders.map((order, index) => (
                    <tr
                      key={index}
                      className="hover:bg-gray-50/50 transition-colors group"
                    >
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <div className="h-10 w-10 flex-shrink-0">
                            {order?.user_id?.profile_image ? (
                              <img
                                className="h-10 w-10 rounded-full object-cover border border-gray-200"
                                src={order.user_id.profile_image}
                                alt=""
                              />
                            ) : (
                              <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold">
                                {order?.user_id?.name?.charAt(0)}
                              </div>
                            )}
                          </div>
                          <div className="ml-4">
                            <div className="text-sm font-semibold text-gray-900">
                              {order?.user_id?.name}
                            </div>
                            <div className="text-xs text-gray-500 uppercase tracking-tighter">
                              {order?.user_id?.staff_id}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                          {order?.affordability}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center text-sm text-gray-600">
                          <FiCalendar className="mr-2 text-gray-400" />
                          {moment(order?.created_at).format("MMM Do YYYY")}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center text-sm text-gray-700">
                          <FiBriefcase className="mr-2 text-gray-400" />
                          {order?.facility}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                        <button
                          onClick={() =>
                            history.push({
                              pathname: "/mart/order-detailed",
                              state: order,
                            })
                          }
                          className="p-2 rounded-full text-gray-400 hover:text-blue-600 hover:bg-blue-50 transition-all"
                        >
                          <FiMoreVertical className="h-5 w-5" />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="5"
                      className="px-6 py-12 text-center text-gray-500 italic"
                    >
                      No booked orders found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* --- Pagination --- */}
          {orders?.length > 0 && (
            <div className="px-6 py-6 border-t border-gray-100 flex justify-center">
              <ReactPaginate
                breakLabel="..."
                nextLabel="Next"
                previousLabel="Prev"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                pageCount={Math.ceil(pageCount / limit)}
                containerClassName="flex items-center space-x-2"
                pageLinkClassName="px-4 py-2 rounded-lg border border-gray-200 text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors"
                previousLinkClassName="px-4 py-2 rounded-lg border border-gray-200 text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors"
                nextLinkClassName="px-4 py-2 rounded-lg border border-gray-200 text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors"
                activeLinkClassName="!bg-blue-600 !text-white !border-blue-600 shadow-sm"
                disabledLinkClassName="opacity-50 cursor-not-allowed"
              />
            </div>
          )}
        </div>

        <ToastContainer autoClose={3000} position="bottom-right" />
      </RenderHirePurchasePage>
    </div>
  );
}

export default ProcessedOrder;
